var map = {
	"./be-bkg.jpg": 5764,
	"./de-bkg.jpg": 2217,
	"./gb-bkg.jpg": 9542,
	"./hk-bkg.jpg": 8427,
	"./hkcb-bkg.jpg": 1951,
	"./kr-bkg.jpg": 8791,
	"./ne-bkg.jpg": 8602,
	"./th-bkg.jpg": 1017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2818;